import styled from '@emotion/styled';
import { css } from 'emotion';

import { SIZES } from '@ezugi/constants';
import { DeviceInfo } from '@ezugi/utils';

const { MOBILE_BUTTON_SIZE } = SIZES;
export const ButtonGroup = styled.div`
  flex: auto;
  flex-shrink: 0;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  padding: 0;

  &.bet-toolbar__button-group--left {
    justify-content: flex-end;
    padding-right: ${DeviceInfo.isHandheld ? 7 : 15}px;
  }

  &.bet-toolbar__button-group--right {
    justify-content: flex-start;
    padding-left: ${DeviceInfo.isHandheld ? 7 : 15}px;
  }
`;

export const verticalButtonGroup = css`
  width: auto;
  height: 50%;
  flex-flow: column;

  &.bet-toolbar__button-group--left {
    justify-content: flex-end;
    padding-right: 0;
    padding-bottom: 12px;
  }

  &.bet-toolbar__button-group--right {
    justify-content: flex-start;
    padding-left: 0;
    padding-top: 12px;
  }
`;

export const mobileButtons = css`
  width: ${MOBILE_BUTTON_SIZE}px;
  height: ${MOBILE_BUTTON_SIZE}px;
  min-width: ${MOBILE_BUTTON_SIZE}px;
  border-radius: ${MOBILE_BUTTON_SIZE / 2}px;
  color: rgba(255, 255, 255, 1);
  font-weight: 500;
  
  > svg {
    width: 20px;
    height: 20px;
  }
`;
